import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-manage-complaints-dashboard',
  standalone: true,
  imports: [
    MatCardModule,
    MatIconModule
  ],
  templateUrl: './manage-complaints-dashboard.component.html',
  styleUrl: './manage-complaints-dashboard.component.scss'
})
export class ManageComplaintsDashboardComponent implements OnInit, AfterViewInit {

  constructor(
    private router: Router
  ) {}

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  navigateToManageJobCards() {
    this.router.navigate(['/app/manage-complaints/manage-job-cards']);
  }

  navigateToCreateComplaint() {
    this.router.navigate(['/app/create-complaint']);
  }

}
